<template>
  <fieldset class="account__form-section">
    <legend class="account__form-section-title layout--margin-bottom-xs">
      Contact Information
    </legend>
    <p class="input-group__directions">
      <i
        >Your contact information appears on your
        <router-link
          class="link"
          to="/dashboard/account/plan-and-billing#payment-history"
          >Invoices</router-link
        ></i
      >
    </p>
    <div class="input-group__wrap">
      <div class="input-group__field-wrap">
        <label for="firstName" class="input-group__label">First Name</label>
        <input
          id="firstName"
          maxlength="128"
          placeholder="First Name"
          class="input-group__input"
          :class="{
            'input-group__input--error': $v.firstName.$invalid,
          }"
          v-model="firstName"
          aria-required="true"
          :aria-invalid="$v.firstName.$invalid"
          aria-describedby="firstNameError"
          @change="handleChange"
        />
        <Error
          :invalid="!$v.firstName.required"
          message="Please enter a first name"
        />
        <Error
          :invalid="!$v.firstName.maxLength"
          message="Last name must be 128 characters or less"
        />
      </div>
      <div class="input-group__field-wrap">
        <label for="lastName" class="input-group__label">Last Name</label>
        <input
          id="lastName"
          maxlength="128"
          class="input-group__input"
          :class="{
            'input-group__input--error': $v.lastName.$invalid,
          }"
          v-model="lastName"
          aria-required="true"
          :aria-invalid="$v.lastName.$invalid"
          @change="handleChange"
        />
        <Error
          :invalid="!$v.lastName.required"
          message="Please enter a last name"
        />
        <Error
          :invalid="!$v.lastName.maxLength"
          message="Last name must be 128 characters or less"
        />
      </div>
      <div class="input-group__field-wrap">
        <label for="companyName" class="input-group__label">Company</label>
        <input
          id="companyName"
          class="input-group__input"
          v-model="companyName"
          aria-required="false"
          @change="handleChange"
        />
      </div>
      <div class="input-group__field-wrap">
        <label for="vat" class="input-group__label">VAT</label>
        <input
          id="vat"
          class="input-group__input"
          v-model="vat"
          aria-required="false"
          @change="handleChange"
        />
      </div>
      <div class="input-group__field-wrap">
        <label for="companyAddress" class="input-group__label"
          >Company Address</label
        >
        <textarea
          id="companyAddress"
          class="input-group__input input-group__input--textarea"
          v-model="companyAddress"
          aria-required="false"
          rows="5"
          cols="22"
          @change="handleChange"
        />
      </div>
    </div>
    <LoadingButton
      :event="saveFormData"
      :loading="$wait.is('saving data')"
      :doneLoading="saved"
    />
  </fieldset>
</template>

<script>
import { mapGetters } from "vuex";
import { mapWaitingActions } from "vue-wait";
import { required, maxLength } from "vuelidate/lib/validators";

import LoadingButton from "../../../components/LoadingButton";
import Error from "../../../components/Error";

/** the name of the section of the form to see if we should show the save button as ghosted or not */
const formSection = "Your Information";

export default {
  name: "YourInformation",
  components: {
    LoadingButton,
    Error,
  },
  mounted() {
    this.firstName = this.user.firstName;
    this.lastName = this.user.lastName;
    this.companyName = this.customer.companyName;
    this.vat = this.customer.vat;
    this.companyAddress = this.customer.companyAddress;
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      companyName: "",
      vat: "",
      companyAddress: "",
      formSection,
      saved: false,
    };
  },
  computed: {
    ...mapGetters("account", ["customer", "user"]),
  },
  methods: {
    ...mapWaitingActions("account", { saveData: "saving data" }),
    saveFormData: function(payload, section) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saved = false;
        const saveFields = [
          { field: "firstName", section: "userDto", value: this.firstName },
          {
            field: "lastName",
            section: "userDto",
            value: this.lastName,
          },
          {
            field: "companyName",
            section: "customer",
            value: this.companyName,
          },
          {
            field: "companyAddress",
            section: "customer",
            value: this.companyAddress,
          },
          { field: "vat", section: "customer", value: this.vat },
        ];
        this.saveData(saveFields).then(() => {
          this.saved = true;
        });
      }
    },
    handleChange: function() {
      this.saved = false;
    },
  },
  validations: {
    firstName: {
      required,
      maxLength: maxLength(128),
    },
    lastName: {
      required,
      maxLength: maxLength(128),
    },
  },
};
</script>

<style></style>
